/**
 * Remote modules to federate into the app.
 * Each object can contain the following:
 * - packageName: The exposed package name.
 * - name: The library name corresponding to its S3 location.
 * - component: The name of the exposed component to render
 * - path: The path to render this application at
 * - hideIntercom?: Hides the Intercom messenger
 * - customAuth?: Turn off automatic authentication
 * - sentryDsn?: The DSN of the Sentry project to send errors to
 * - configcatProjectKey?: The key of your ConfigCat project
 * - devHost?: An optional host to use instead of loading from beta-clients.mintel.com
 * - allowNonBridge?: Allows legacy apps to skip the bridge (true for all current apps); omit for new apps
 */
module.exports = [
  {
    packageName: 'helloFrontend',
    name: 'hello-frontend',
    component: 'Hello',
    customAuth: true,
    path: '/hello-frontend',
    devHost: '',
    allowNonBridge: true,
  },
  {
    packageName: 'helloMgl',
    name: 'hello-mgl',
    component: 'Pie',
    path: '/hello-mgl',
    sentryDsn:
      'https://5890c680fbd2471cb9f4d6fbf8fbd9d2@o93565.ingest.sentry.io/6395617',
    configcatProjectKey: '_-rZCDqEH0uIKFPcfMjYpQ/YRjz8SaObUGFHhPny6jFiQ',
    customAuth: true,
    devHost: '',
    hasSiteNav: true,
    events: {
      listening: ['SiteNav Link Click'],
    },
  },
  {
    packageName: 'compereLifecycle',
    name: 'compere-lifecycle',
    component: 'App',
    path: '/journeys',
    devHost: '',
    allowNonBridge: true,
    activeProduct: 'compere',
  },
  {
    packageName: 'dataLabs',
    name: 'data-labs',
    component: 'App',
    path: '/data-labs',
    devHost: '',
    allowNonBridge: true,
    activeProduct: 'compere',
  },
  {
    packageName: 'gnpdDataEntry',
    name: 'gnpd-data-entry',
    component: 'App',
    path: '/gnpd-data-entry',
    sentryDsn:
      'https://e768a20649d399b05ba5a5d5005f2d1f@o93565.ingest.sentry.io/4505669438341120',
    hideIntercom: true,
    devHost: '',
    allowNonBridge: true,
  },
  {
    packageName: 'gnpdRuleManagement',
    name: 'gnpd-rule-management',
    component: 'App',
    path: '/gnpd-rule-management',
    sentryDsn:
      'https://2d02db76ef364dcf658e180b96a8f88e@o93565.ingest.us.sentry.io/4508302930608128',
    hideIntercom: true,
    devHost: '',
    allowNonBridge: true,
  },
  {
    packageName: 'gnpdWorkflowManagement',
    name: 'gnpd-workflow-management',
    component: 'App',
    path: '/gnpd-workflow-management',
    sentryDsn:
      'https://71b81ab4e80e8631ac53c50d3a2d6342@o93565.ingest.us.sentry.io/4508834052505600',
    hideIntercom: true,
    devHost: '',
    allowNonBridge: true,
  },
  {
    packageName: 'gnpdItemRepresentation',
    name: 'gnpd-item-representation',
    component: 'App',
    path: '/gnpd-item-representation',
    hideIntercom: true,
    devHost: '',
    allowNonBridge: true,
  },
  {
    packageName: 'competitiveTargeting',
    name: 'competitive-targeting',
    component: 'App',
    path: '/competitive-targeting',
    devHost: '',
    allowNonBridge: true,
    activeProduct: 'compere',
  },
  {
    packageName: 'competitiveTargeting',
    name: 'competitive-targeting',
    component: 'DemoCompApp',
    path: '/demographic-comparison',
    devHost: '',
    allowNonBridge: true,
    activeProduct: 'compere',
  },
  {
    packageName: 'cwaContentPageApp',
    name: 'cwa-content-page-app',
    component: 'MyAccount',
    path: '/my-account-and-settings',
    devHost: '',
    configcatProjectKey: 'FG_aCI1-K0qH1_jP510vyg/QZZE3fXVNke3ltrxCTz4RQ',
    sentryDsn:
      'https://c951f54c6e85466cbffc0e787947de9a@o93565.ingest.sentry.io/6509215',
  },
  {
    packageName: 'cwaContentPageApp',
    name: 'cwa-content-page-app',
    component: 'App',
    path: '/content',
    customAuth: true,
    sentryDsn:
      'https://c951f54c6e85466cbffc0e787947de9a@o93565.ingest.sentry.io/6509215',
    configcatProjectKey: 'FG_aCI1-K0qH1_jP510vyg/QZZE3fXVNke3ltrxCTz4RQ',
    devHost: '',
    allowNonBridge: true,
    activeProduct: 'insights',
  },
  {
    packageName: 'flavourscape',
    name: 'flavourscape',
    component: 'App',
    path: '/flavourscape',
    sentryDsn:
      'https://e8929f9a171b40179e8460b418326fd9@o93565.ingest.sentry.io/6581626',
    configcatProjectKey: '_-rZCDqEH0uIKFPcfMjYpQ/-guSqKb7pEmB5Vy3MLaomQ',
    devHost: '',
    allowNonBridge: true,
    activeProduct: 'gnpd',
  },
  {
    packageName: 'scapes',
    name: 'scapes',
    component: 'App',
    path: '/scapes',
    sentryDsn:
      'https://e8929f9a171b40179e8460b418326fd9@o93565.ingest.sentry.io/6581626',
    configcatProjectKey: '_-rZCDqEH0uIKFPcfMjYpQ/-guSqKb7pEmB5Vy3MLaomQ',
    devHost: '',
    allowNonBridge: true,
    hasSiteNav: true,
    activeProduct: 'gnpd',
    events: {
      listening: ['SiteNav Link Click'],
    },
  },
  {
    packageName: 'kimberlyClarkWhiteLabel',
    name: 'kimberlyClarkWhiteLabel',
    component: 'App',
    path: '/kimberly-clark-white-label',
    devHost: '',
    allowNonBridge: true,
  },
  {
    packageName: 'portalRegistration',
    name: 'portal-registration',
    component: 'App',
    path: '/registration',
    sentryDsn:
      'https://e0a89b8956f8407da4e5e2d1d1b426cd@o93565.ingest.sentry.io/4505001899261952',
    customAuth: true,
    devHost: '',
    allowNonBridge: true,
  },
  {
    packageName: 'onecompere',
    name: 'one-compere',
    component: 'App',
    path: '/onecompere',
    sentryDsn:
      'https://140c5a1f9af448d2f7229169048a3ba6@o93565.ingest.sentry.io/4506514778619904',
    configcatProjectKey: 'M2fZCEJGY0yDUNiG7M68hw/8lhHSZKbekGUpWQyw5Xx-Q',
    devHost: '',
    allowNonBridge: true,
    activeProduct: 'onecompere',
  },
  {
    packageName: 'cpgNotificationsManager',
    name: 'cpg-notifications-manager',
    component: 'App',
    path: '/cpg-notifications-manager',
    devHost: '',
    allowNonBridge: true,
  },
  {
    packageName: 'comperemediaDiscover',
    name: 'comperemedia-discover',
    component: 'App',
    path: '/comperemedia-discover',
    devHost: '',
    sentryDsn:
      'https://6545fa550eba7ebbe17a23ec18b29777@o93565.ingest.sentry.io/4506303278284800',
    allowNonBridge: true,
    activeProduct: 'compere',
  },
  {
    packageName: 'comperemediaMastercard',
    name: 'comperemedia-mastercard',
    component: 'App',
    path: '/comperemedia-mastercard',
    devHost: '',
    sentryDsn:
      'https://17d4660ba4bc67567900475cf522c80a@o93565.ingest.sentry.io/4506303280906240',
    allowNonBridge: true,
    activeProduct: 'compere',
  },
  {
    packageName: 'leap',
    name: 'leap',
    component: 'App',
    path: '/home',
    devHost: '',
    configcatProjectKey: '_-rZCDqEH0uIKFPcfMjYpQ/BtDG-2W4_EmRPK57hT8i3Q',
    sentryDsn:
      'https://e3f5fa2a7b016f8b7593f6bb3a6a99ba@o93565.ingest.sentry.io/4506360502812672',
    activeProduct: 'leap',
  },
  {
    packageName: 'gnpdCategoryLandingPage',
    name: 'gnpd-category-landing-page',
    component: 'App',
    path: '/gnpd-hub',
    devHost: '',
    configcatProjectKey: '_-rZCDqEH0uIKFPcfMjYpQ/GiNmYjg_8UO7xqI7SuiEvg',
    sentryDsn:
      'https://f15989f5e77af6640e3258fe9aa229ed@o93565.ingest.sentry.io/4506656224116736',
    allowNonBridge: true,
    activeProduct: 'gnpd',
  },
  {
    packageName: 'maturity_map_creator',
    name: 'maturity-map-creator',
    component: 'App',
    path: '/maturity-map-creator',
    devHost: '',
    sentryDsn:
      'https://5a868f47624624f064dca927a29869f5@o93565.ingest.us.sentry.io/4507491967107072',
    allowNonBridge: true,
  },
  {
    packageName: 'claimsExplorer',
    name: 'claims-explorer',
    component: 'App',
    path: '/claims-explorer',
    devHost: '',
    configcatProjectKey:
      'configcat-sdk-1/_-rZCDqEH0uIKFPcfMjYpQ/pTXxCM96OEGD8411b-JtHA',
    sentryDsn:
      'https://b279f0c1b48e74dbac5662151532e3d3@o93565.ingest.us.sentry.io/4507572161216512',
    allowNonBridge: true,
    activeProduct: 'gnpd',
  },
  {
    packageName: 'spark',
    name: 'spark',
    component: 'App',
    path: '/spark',
    devHost: '',
    configcatProjectKey:
      'configcat-sdk-1/_-rZCDqEH0uIKFPcfMjYpQ/3bjE5srJsk64v-ZwFcA3_A',
    sentryDsn:
      'https://bfdf0e2727d1028b11e36b391091c641@o93565.ingest.us.sentry.io/4508283510718464',
    allowNonBridge: true,
    activeProduct: 'gnpd',
  },
  {
    packageName: 'competitiveAnalyzer',
    name: 'competitive-analyzer',
    component: 'App',
    path: '/competitive-analyzer',
    devHost: '',
    configcatProjectKey:
      'configcat-sdk-1/_-rZCDqEH0uIKFPcfMjYpQ/zvLzdRBayE6tShSf6P7zig',
    sentryDsn: '',
    allowNonBridge: true,
  },
  {
    packageName: 'portalWebApp',
    name: 'portal-web-app',
    component: 'App',
    path: '/shibboleth-discovery-service',
    devHost: '',
    customAuth: true,
    allowNonBridge: true,
  },
  {
    packageName: 'custom_data_tagging',
    name: 'custom-data-tagging',
    component: 'App',
    path: '/custom-data-tagging',
    devHost: '',
    sentryDsn:
      'https://7e0b052d2b5e3c7502c2e69e7a2d191b@o93565.ingest.us.sentry.io/4508454518587392',
    allowNonBridge: true,
  },
  {
    packageName: 'analytics_embedding',
    name: 'analytics-embedding',
    component: 'App',
    path: '/analytics-embedding',
    devHost: '',
    sentryDsn:
      'https://c30b3866110d6d6b8ec794cea9aa811f@o93565.ingest.us.sentry.io/4508846092189697',
    allowNonBridge: true,
  },
  {
    packageName: 'muse_prototype',
    name: 'muse_prototype',
    component: 'App',
    path: '/muse',
    devHost: '',
    sentryDsn:
      'https://2a5c1d8830711358f4a19a4b5acce634@o93565.ingest.us.sentry.io/4509405897097216',
    configcatProjectKey:
      'configcat-sdk-1/_-rZCDqEH0uIKFPcfMjYpQ/26xu7xVFDEipTKhgefG_5w',
  },
];
